import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useSelectedWatchlist } from '@/pages/Watchlist/hooks/useSelectedWatchlist';

import { queryFn } from './watchlistQueryFn';
import useUser from '../useUser';

export const QUERY_KEY = ['WATCHLIST'] as const;

const isError = (e: unknown): e is Error =>
  typeof e !== 'undefined' &&
  'name' in (e as Error) &&
  'message' in (e as Error);

export function useWatchlist() {
  const [watchlistId, selectWatchlist] = useSelectedWatchlist();
  const { data: user } = useUser();

  const query = useQuery({
    queryKey: [...QUERY_KEY, watchlistId],
    queryFn,
    enabled: typeof watchlistId !== 'undefined' && user.loggedIn,
    staleTime: 3600000,
    retry: 1,
    meta: {
      tags: ['narrative', 'watchlist'],
    },
  });

  const { error, status } = query;
  useEffect(() => {
    if (status === 'error') {
      if (
        isError(error) &&
        /Watchlist with id: .* could not be found/.test(error.message)
      ) {
        selectWatchlist(null);
      }
    }
  }, [error, status, selectWatchlist]);

  return query;
}
